// extracted by mini-css-extract-plugin
export default {"container":"gDjyen03z0yRth3GGtCk","shoobBlueText":"fj8XzlJDlXX8GcHv3Vkt","title":"lLzoTHhv9sumedGo2438","noStudentMsg":"SN8EVs1h_IfyNSrdhbxt"};